type CreateItem = {
  productTitle: string
  variantTitle: string
  priceAmount: string
  currency: string
  index: number
  quantity: number
}

export const createItem = ({
  productTitle,
  currency,
  index,
  variantTitle,
  priceAmount,
  quantity,
}: CreateItem) => {
  return {
    item_name: productTitle,
    currency,
    index,
    item_variant: variantTitle,
    price: parseFloat(priceAmount),
    quantity,
  }
}
